// Matching modules are required into this module.
function requireAll(requireContext) {
    return requireContext.keys().map(requireContext);
}

require('normalize.css');
require('font-awesome/css/font-awesome.css');
requireAll(require.context("../components/wraaa/", true, /\.css$/));
requireAll(require.context("../components/wraaa/", true, /\.js$/));